<template>
  <div class="mb-3">
    <div class="mc-user-modal__user-info-card">
      <div class="mc-user-modal__user-avatar">
        <i class="icon-fill_person"></i>
      </div>
      <div class="mc-user-modal__user-details">
        <h6 class="mc-user-modal__user-name">
          {{ userData.fullname || userData.name }}
        </h6>
        <p class="mc-user-modal__user-meta">
          {{ getUserTypeText }}
          <span class="mc-user-modal__separator-dot"></span>
          {{ userData.group || userData.position?.name }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserInfoHeader',

  props: {
    userData: {
      type: Object,
      required: true,
    },
  },

  computed: {
    getUserTypeText() {
      if (this.userData.isDriver) {
        return this.$t('master.driver')
      }
      if (this.userData.isEmployee) {
        return this.$t('master.karyawan')
      }
      return ''
    },
  },
}
</script>
